import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDrag = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 3C12.2652 3 12.5196 3.10536 12.7071 3.29289L15.2071 5.79289C15.5976 6.18342 15.5976 6.81658 15.2071 7.20711C14.8166 7.59763 14.1834 7.59763 13.7929 7.20711L13 6.41421V17.5858L13.7929 16.7929C14.1834 16.4024 14.8166 16.4024 15.2071 16.7929C15.5976 17.1834 15.5976 17.8166 15.2071 18.2071L12.7071 20.7071C12.3166 21.0976 11.6834 21.0976 11.2929 20.7071L8.79289 18.2071C8.40237 17.8166 8.40237 17.1834 8.79289 16.7929C9.18342 16.4024 9.81658 16.4024 10.2071 16.7929L11 17.5858V6.41421L10.2071 7.20711C9.81658 7.59763 9.18342 7.59763 8.79289 7.20711C8.40237 6.81658 8.40237 6.18342 8.79289 5.79289L11.2929 3.29289C11.4804 3.10536 11.7348 3 12 3Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M21 12C21 12.2652 20.8946 12.5196 20.7071 12.7071L18.2071 15.2071C17.8166 15.5976 17.1834 15.5976 16.7929 15.2071C16.4024 14.8166 16.4024 14.1834 16.7929 13.7929L17.5858 13L6.41421 13L7.20711 13.7929C7.59763 14.1834 7.59763 14.8166 7.20711 15.2071C6.81658 15.5976 6.18342 15.5976 5.79289 15.2071L3.29289 12.7071C2.90237 12.3166 2.90237 11.6834 3.29289 11.2929L5.79289 8.79289C6.18342 8.40237 6.81658 8.40237 7.20711 8.79289C7.59763 9.18342 7.59763 9.81658 7.20711 10.2071L6.41421 11L17.5858 11L16.7929 10.2071C16.4024 9.81658 16.4024 9.18342 16.7929 8.79289C17.1834 8.40237 17.8166 8.40237 18.2071 8.79289L20.7071 11.2929C20.8946 11.4804 21 11.7348 21 12Z",
		fill: "currentColor"
	})]
});
export default SvgDrag;
